import { render, staticRenderFns } from "./starDisplay.vue?vue&type=template&id=7bf2925c&"
import script from "./starDisplay.vue?vue&type=script&lang=js&"
export * from "./starDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bf2925c')) {
      api.createRecord('7bf2925c', component.options)
    } else {
      api.reload('7bf2925c', component.options)
    }
    module.hot.accept("./starDisplay.vue?vue&type=template&id=7bf2925c&", function () {
      api.rerender('7bf2925c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Yjz536FajQ44/JS/starDisplay.vue"
export default component.exports